import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Auth } from 'aws-amplify';
import { VerifySoftwareTokenCommand } from '@clearing-hub/command';
import { AngularCommonService } from '../../service/angular-common.service';
import { MfaSettingsComponent } from '@baxter-jenkins/mfa-settings';

@Component({
  selector: 'baxter-library-mfa-settings-cognito',
  templateUrl: './mfa-settings-cognito.component.html',
  styleUrl: './mfa-settings-cognito.component.scss',
})
export class MfaSettingsCognitoComponent {

  @ViewChild('mfaSettingsComponent', {static: true})
  mfaSettingsComponent: MfaSettingsComponent;

  @Input()
  toastr: any;

  associateResp: any;

  user: any;

  secretCode: string;

  setAuthenticatorApp: boolean;

  constructor(private readonly fb: FormBuilder,
              private readonly angularCommonService: AngularCommonService) {
  }

  enableSetAuthenticatorApp() {
    this.angularCommonService.associateSoftwareToken().subscribe(async (resp) => {
      this.associateResp = resp;
      this.mfaSettingsComponent.setAuthenticatorApp = true;
      const user = await Auth.currentAuthenticatedUser();
      const issuer = 'FXCH';
      this.mfaSettingsComponent.qrCode = `otpauth://totp/${encodeURIComponent(issuer + ':' + user.attributes.email)}?secret=${resp.secretCode}&issuer=${encodeURIComponent(issuer)}`;
      this.secretCode = resp.secretCode;
    });
  }

  verifySoftwareToken() {
    if (this.mfaSettingsComponent.formGroup.invalid) {
      return;
    }
    const command: VerifySoftwareTokenCommand = {
      code: this.mfaSettingsComponent.formGroup.get('code').value,
      token: this.associateResp.token,
      session: this.associateResp.session
    };
    this.angularCommonService.verifySoftwareToken(command).subscribe(async (resp) => {
      this.toastr.success('Software token successfully added to your account.');
      await this.refreshUserData();
      this.setAuthenticatorApp = false;
      this.associateResp = null;
      this.mfaSettingsComponent.qrCode = null;
    });
  }


  async refreshUserData() {
    try {
      this.user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    } catch (error) {
      console.error('Error refreshing user data', error);
    }
  }

}
